import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { forwardRef, createElement } from 'react';
import { useStyles } from '../styles/index.js';
import { TextElementTypes } from '../types/index.js';
import { TypographyT5 } from '../../../../foundation/typography/typography/index.js';
import { TextColors } from '../../../../foundation/colors/textColors/textColors/index.js';
import { FontWeights } from '../../../../foundation/fonts/fonts/index.js';
import { computeResponsiveness } from '../../../../foundation/responsive/helpers/index.js';

const Tag = ({ tagName, children, ...props }) => createElement(tagName, props, children);
const Text = forwardRef(({ children, elementType = TextElementTypes.Span, weight = FontWeights.normal, size = TypographyT5, align, preventNextLine, maxVisibleLinesCount, isFullWidth, color = TextColors.base, dataTestId, className, htmlFor, ...props }, ref) => {
    const sizes = computeResponsiveness(size);
    const styles = useStyles({
        sizes, align, weight, preventNextLine, maxVisibleLinesCount, isFullWidth, color,
    });
    return (jsx(Tag, { ...(elementType === TextElementTypes.Label && { htmlFor }), tagName: elementType, "data-testid": dataTestId || 'text', ref: ref, className: clsx(styles.root, className), ...props, children: children }));
});
Text.displayName = 'Text';

export { Text };
